import type { UserProfile } from '@skychat/shared-core';

export function resolveIncomingTypingEntry(
  data: Record<string, unknown>,
  friend: UserProfile | undefined,
  userId: string
) {
  const incomingAnimation = String(
    data.typingStyle || data.style || data.typingAnimation || data.typing_animation || ''
  ).trim();
  const incomingCustomUrl = String(data.customTypingAnimationUrl || data.custom_typing_animation_url || '').trim();
  const profileAnimation = String(friend?.typing_animation || '').trim();

  const typingAnimation = incomingCustomUrl
    ? 'custom'
    : (incomingAnimation && incomingAnimation !== 'default'
      ? incomingAnimation
      : (profileAnimation || incomingAnimation || 'default'));
  const customTypingAnimationUrl = typingAnimation === 'custom'
    ? (incomingCustomUrl || String(friend?.custom_typing_animation_url || ''))
    : '';

  return {
    userId,
    // Older servers/clients use "default" as a generic fallback. Prefer the
    // persisted peer style in that case, matching the desktop client.
    typing_animation: typingAnimation === 'custom' && !customTypingAnimationUrl ? 'default' : typingAnimation,
    custom_typing_animation_url: customTypingAnimationUrl
  };
}
